import { render, staticRenderFns } from "./FormInputs.vue?vue&type=template&id=f8104e10&scoped=true"
import script from "./FormInputs.vue?vue&type=script&lang=js"
export * from "./FormInputs.vue?vue&type=script&lang=js"
import style0 from "./FormInputs.vue?vue&type=style&index=0&id=f8104e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8104e10",
  null
  
)

export default component.exports